import { render, staticRenderFns } from "./ks-investor-2.vue?vue&type=template&id=5f610345"
var script = {}
import style0 from "./ks-investor-2.vue?vue&type=style&index=0&id=5f610345&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports